module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAnyNotes) ? _c('span', {
    staticClass: "note-hover",
    on: {
      "mouseenter": _vm.openPopover,
      "mouseleave": _vm.closePopover
    }
  }, [_c('i', {
    staticClass: "fas fa-sticky-note note-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPopoverVisible),
      expression: "isPopoverVisible"
    }],
    staticClass: "note-popover",
    class: {
      above: _vm.isPopoverAbove
    }
  }, [(_vm.hasInternalNote) ? _c('div', {
    staticClass: "note-card internal"
  }, [_c('div', {
    staticClass: "note-title"
  }, [_vm._v("Internal note:")]), _vm._v(" "), _c('div', {
    staticClass: "note-body",
    attrs: {
      "title": _vm.internalNote
    }
  }, [_vm._v(_vm._s(_vm.limitedInternalnote))])]) : _vm._e(), _vm._v(" "), (_vm.hasNote) ? _c('div', {
    staticClass: "note-card external"
  }, [_c('div', {
    staticClass: "note-title"
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('div', {
    staticClass: "note-body",
    attrs: {
      "title": _vm.note
    }
  }, [_vm._v(_vm._s(_vm.limitedNote))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6688466f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6688466f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/reservationLists/NotesHover.vue
// module id = 2774
// module chunks = 0